import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignedToComponent } from '../assigned-to/assigned-to.component';
import { VMEComponentsModule } from '../../../vme-components.module';
import { IRiskManagementSupplier } from '../../../interfaces/supplier-risk-management/supplier-risk-management';
import { SupplierClassificationComponent } from '../../telephony/supplier-information/supplier-classification/supplier-classification.component';
import { SupplierRiskManagementService } from '../../../services/supplier-risk-management.service';
import { MessageService, SelectItem } from 'primeng';
import { Message } from '../../../classes/Message';
import { MapService } from '../../../services';
import { RiskManagementSelectedSupplierTaskComponent } from '../risk-management-selected-supplier-task/risk-management-selected-supplier-task.component';
import {
  ReviewStatusChange,
  ReviewStatusChangeWithSupplier,
} from '../../../interfaces/supplier-risk-management/review-status-change';

@Component({
  selector: 'risk-management-selected-supplier',
  standalone: true,
  imports: [
    CommonModule,
    AssignedToComponent,
    VMEComponentsModule,
    RiskManagementSelectedSupplierTaskComponent,
    SupplierClassificationComponent,
  ],
  templateUrl: './risk-management-selected-supplier.component.html',
  styleUrls: ['./risk-management-selected-supplier.component.css'],
})
export class RiskManagementSelectedSupplierComponent implements OnChanges {
  @Input() riskManagementSupplier: IRiskManagementSupplier;
  @Output() assignedUserChange: EventEmitter<string> = new EventEmitter<string>();

  staticMapSrc: string;

  constructor(
    private supplierRiskManagementService: SupplierRiskManagementService,
    public messageService: MessageService,
    private mapService: MapService,
  ) {}

  protected taskIds: number[] = [];

  ngOnChanges(changes: SimpleChanges) {
    this.prepData();
  }

  prepData() {
    this.taskIds = this.riskManagementSupplier.tasks.map((x) => x.taskId);
    this.selectedTaskId = this.taskIds[0];
  }

  protected selectedTaskId: number = 0;

  protected async handleAssigneeChanged(assignee: SelectItem) {
    let originalAssigneeId = this.riskManagementSupplier.assigneeId;

    try {
      if (!assignee) {
        await this.supplierRiskManagementService.unassignUser(
          this.riskManagementSupplier.supplierId,
        );
        this.assignedUserChange.emit(null);
        this.riskManagementSupplier.assigneeId = null;
        this.riskManagementSupplier.assigneeName = null;
      } else {
        await this.supplierRiskManagementService.assignUser(
          this.riskManagementSupplier.supplierId,
          assignee.value,
        );
        this.riskManagementSupplier.assigneeId = assignee.value;
        this.riskManagementSupplier.assigneeName = assignee.label;
        this.assignedUserChange.emit(assignee.value);
      }
    } catch (error: any) {
      this.riskManagementSupplier.assigneeId = originalAssigneeId;
      if (error.status === 403) {
        this.messageService.add(
          Message.Error('You do not have permission to change other user assignments.', 'Error'),
        );
      } else {
        throw error;
      }
    }
  }

  protected changeSelectedTask(taskId: number) {}

  @Output() reviewStatusChange = new EventEmitter<ReviewStatusChangeWithSupplier>();
  protected handleReviewStatusChange(reviewStatusChange: ReviewStatusChange): void {
    let change: ReviewStatusChangeWithSupplier = {
      ...reviewStatusChange,
      supplierId: this.riskManagementSupplier.supplierId,
    };
    this.reviewStatusChange.emit(change);
  }

  protected trackByTaskId(index: number, task: any): number {
    return task.taskId;
  }
}
